import logger from './logger'
import router from './router'
import thunk from 'redux-thunk';

export const middleware = [
  thunk,
  logger,
  router,
]